class MoreOptionsDrawer extends Drawer {
  connectedCallback() {
    // hoistOutOfQuickBuy moves this element, which fires connectedCallback a second time.
    // Listeners survive a move, so re-running the base class would only double them up.
    if (this.initialised) return;
    this.initialised = true;

    super.connectedCallback();
    this.hoistOutOfQuickBuy();
  }

  hoistOutOfQuickBuy() {
    if (!this.closest('.drawer__content')) return;

    this.classList.add('more-options-drawer--quick-buy');

    document.querySelectorAll('more-options-drawer.more-options-drawer--quick-buy')
      .forEach((drawer) => {
        if (drawer !== this) drawer.remove();
      });

    document.body.appendChild(this);
  }

  close() {
    super.close();

    if (document.querySelector('.drawer.active')) {
      document.body.classList.add('overflow-hidden');
    }
  }
}

class MoreOptionsDrawerButton extends DrawerButton {
  constructor() {
    super();
    this.handleClick = this.handleClick.bind(this);
  }

  connectedCallback() {
    this.drawerTag = this.dataset.drawerTag;
    this.productId = this.dataset.productId;
    this.triggerButton = this.querySelector('button');

    if (!this.drawerTag) {
      return;
    }

    this.addEventListener('click', this.handleClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.handleClick);
  }

  addDrawerListener() {
    super.addDrawerListener();
    this.drawer.addEventListener(`${this.drawerTag}:toggle`, (evt) => {
      this.triggerButton?.setAttribute('aria-expanded', evt.detail.action === 'open');
    });
  }

  handleClick() {
    if (!this.drawer) {
      this.drawer = document.querySelector(`${this.drawerTag}.more-options-drawer--${this.productId}`);
      if (!this.drawer) return;

      this.addDrawerListener();
    }

    this.toggleDrawer();
  }
}

// Safari's page cache restores the DOM verbatim on back/forward without re-running scripts, so a
// drawer left open comes back open. Close it before the page is cached, so the snapshot is already
// closed and nothing animates on arrival.
window.addEventListener('pagehide', () => {
  document.querySelectorAll('more-options-drawer.active').forEach((drawer) => drawer.close?.());
});

// Fallback for browsers that cache the open state anyway. 'noAnimation' shuts it without the fade,
// the same way the facets side drawer suppresses its restore animation.
window.addEventListener('pageshow', (event) => {
  if (!event.persisted) return;

  document.querySelectorAll('more-options-drawer.active').forEach((drawer) => {
    drawer.classList.add('noAnimation');
    drawer.close?.();
    requestAnimationFrame(() => requestAnimationFrame(() => drawer.classList.remove('noAnimation')));
  });
});

customElements.define('more-options-drawer', MoreOptionsDrawer);
customElements.define('more-options-drawer-button', MoreOptionsDrawerButton);
